import { List, ModelBase, NeoModel} from '@singularsystems/neo-core';
import KeyValuePair from './KeyValuePair';

@NeoModel
export default class CreatableDropDownAnswerType extends ModelBase {

    // Properties
    public dropDownItems = new List(KeyValuePair)
}